import { SearchBarWrapper } from "./SearchBarStyles";
import { useSearchParams } from "react-router-dom";
import styled from "styled-components";
import type { SearchInputChangeEventValue } from "@dealer-center/core-components";
import { SearchInput } from "@dealer-center/core-components";
/**
 * An Search component
 * @constructor
 */

const StyledSearchInput = styled(SearchInput)`
  margin: 1rem;
`;

const SearchBar = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const inputValue = searchParams.get("accountId");

  const handleSearch = (value: SearchInputChangeEventValue) => {
    if (!value) return;
    setSearchParams(prevParams => {
      prevParams.set("accountId", value);
      return prevParams;
    });
  };

  return (
    <SearchBarWrapper>
      <StyledSearchInput
        data-testid="account-search"
        id="account-search"
        inputValue={inputValue || ""}
        name="accountId"
        placeholder="Enter Dealer ID"
        size={"medium"}
        sx={{ width: "500px" }}
        onSearchClick={inputBox => {
          handleSearch(inputBox.target.value);
        }}
      />
    </SearchBarWrapper>
  );
};

export default SearchBar;
